import { clsx, type ClassValue } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";

/**
 * Tokens de TAMANHO de fonte do Design System.
 *
 * Esta lista existe para resolver uma ambiguidade real do Tailwind: `text-` é
 * prefixo tanto de tamanho (`text-ds-body`) quanto de cor (`text-ds-on-solid`).
 * Sem essa distinção, o tailwind-merge trata os dois como o mesmo grupo e
 * descarta o primeiro — na prática, a cor do texto sumia e o texto herdava
 * `ds-ink-900`. Era isso que deixava o botão primário com tinta escura sobre o
 * laranja.
 *
 * Ao criar um token `--text-ds-*` novo em globals.css, acrescente-o aqui.
 */
const DS_FONT_SIZES = [
  "ds-caption",
  "ds-small",
  "ds-body",
  "ds-lead",
  "ds-h4",
  "ds-h3",
  "ds-h2",
  "ds-h1",
  "ds-display",
];

const isDsFontSize = (value: string) => DS_FONT_SIZES.includes(value);
/** Todo `text-ds-*` que não é tamanho é cor. */
const isDsTextColor = (value: string) =>
  value.startsWith("ds-") && !DS_FONT_SIZES.includes(value);
const isDsToken = (value: string) => value.startsWith("ds-");

const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      "font-size": [{ text: [isDsFontSize] }],
      "text-color": [{ text: [isDsTextColor] }],
      // Sem isto, `rounded-ds-md rounded-ds-lg` sobreviviam juntos e o resultado
      // dependia da ordem no CSS em vez da ordem no className.
      rounded: [{ rounded: [isDsToken] }],
    },
  },
});

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
